import React from "react";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Api } from "../../utils/api";
import { PaymentDetails } from "../components/payment_details.component";
import AlertDialog from "../../components/alert.component";
import moment from "moment";

export class PaymentDetailsForm extends React.Component {
  state = {
    showAlert: false,
    alertTitle: null,
    alertMessage: null,
    nextPayments: [],
  };

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.submit = this.submit.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.showAlert = this.showAlert.bind(this);
  }

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert = () => {
    this.setState({ showAlert: false });
    window.location.reload();
  };

  submit() {
    let success = true;
    const newPayments = this.state.nextPayments;
    const easypay_payment = this.props.payment;
    const today = moment().format("YYYY-MM-DD");
    newPayments.map((payment) => {
      const id = payment.ep_key;
      const data = {
        easypay_reference_id: easypay_payment.easypay_reference_id,
        ep_value: payment.ep_value,
        payment_at: payment.payment_at,
        description: payment.description ? payment.description : "",
        observations: payment.observations ? payment.observations : "",
        invoice_id: payment.invoice_id ? payment.invoice_id : null,
        ep_status: moment(payment.payment_at).isAfter(today)
          ? "pending"
          : "nok",
        ep_payment_type: payment.ep_payment_type,
        establishments_request_id: payment.establishments_request_id,
      };
      if (payment.edited) {
        if (!payment.toAdd)
          if (payment.toDelete)
            //delete
            this.api
              .delete(`/easypay_payments/${id}`)
              .then((res) => {
                console.log("delete " + id + ": ", res);
              })
              .catch((err) => {
                console.log("delete " + id + ": ", err);
                success = false;
              });
          //update
          else {
            this.api
              .patch(`/easypay_payments/${id}`, { ...data })
              .then((res) => {
                console.log("patch " + id + ": ", res);
              })
              .catch((err) => {
                console.log("patch " + id + ": ", err);
                success = false;
              });
          }
        //create
        else
          this.api
            .post(`/easypay_payments`, data)
            .then((res) => {
              console.log("post : ", res);
            })
            .catch((err) => {
              console.log("post " + id + ": ", err);
              success = false;
            });
      }
      if (success)
        this.showAlert("Sucesso", "Alterações guardadas com sucesso!");
      else this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
    });
  }

  render() {
    this.state.nextPayments = this.props.nextPayments;

    return (
      <>
        <PaymentDetails
          onSubmit={this.handleSubmitting}
          getForm={this.setForm}
          payment={this.props.payment}
          nextPayments={this.state.nextPayments}
        />

        <ExpansionPanelActions>
          <Grid container>
            <Dialog>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={this.handleClose} color="primary">
                  Save
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          <Button size="small">Cancel</Button>
          <Button size="small" color="primary" onClick={() => this.submit()}>
            Save
          </Button>
        </ExpansionPanelActions>

        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </>
    );
  }
}
